export default __webpack_public_path__ + "static/media/NotiPreventive.5dc0700e.svg";